<template>
    <div class="validatable">
        <slot />
    </div>
</template>

<script>
export default {
    methods: {
        validate () {
            let validated = true

            this.$children.forEach(child => {
                if (typeof child.validate === "undefined") {
                    console.warn('Child element of Validatable is not a valid form item: the validate() method is not defined in: ', child)
                }
                else {
                    let result = child.validate()

                    validated = validated && result
                }
            })

            return validated
        }
    }
}
</script>